import L from "leaflet"
import iconMarker from "./assets/marker.png"

export const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8080/api/"
    : "https://hessel-osm.herokuapp.com/api/"

export const MAP_GEO_LOCATION = [56.174, 10.548]
export const MAP_ZOOM = 6.5
export const MAP_DOM_ID = "osm-container"
export const MAP_OPTIONS = {
  attributionControl: false,
  zoom: 1,
  zoomAnimation: false,
  scrollWheelZoom: false,
  tap: false,
  touchZoom: false,
  keyboard: false,
  zoomControl: true,
  dragging: true,
  doubleClickZoom: true,
  minZoom: 6,
}

export const ICON_OPTIONS = {
  iconUrl: iconMarker,
  iconSize: [20, 28],
  iconAnchor: [5, 28],
  shadowAnchor: [4, 62],
  popupAnchor: [5, -32],
}

export const ICON = L.icon(ICON_OPTIONS)

export const GROUPED_LOCATION_IDS = [
  [1275, 31828], // Aarhus
  [1271, 51653], // Thisted
]

export const getMarkerPopupText = (location) => {
  if (!location) return ""
  const { name, subtitle, adress, zip, city, phone, email, url } = location

  let text = ""
  text += name ? `<b>${name}</b><br/>` : ""
  text += subtitle ? `${subtitle}<br/>` : ""
  text += "<br/>"
  text += adress ? `${adress}<br/>` : ""
  text += zip || city ? `${zip} ${city}<br/>` : ""
  text += phone ? `Telefon: ${phone}<br/>` : ""
  text += email ? `Email: ${email}<br/><br/>` : ""
  text += url ? `<a href="https://www.hessel.dk${url}">Vis forhandler</a>` : ""

  return text
}

export const iconArrowRight = `data:image/svg+xml;base64,PHN2ZyBpZD0iU3ZnanNTdmcxMDAxIiB3aWR0aD0iMjg4IiBoZWlnaHQ9IjI4OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWxuczpzdmdqcz0iaHR0cDovL3N2Z2pzLmNvbS9zdmdqcyI+PGRlZnMgaWQ9IlN2Z2pzRGVmczEwMDIiPjwvZGVmcz48ZyBpZD0iU3ZnanNHMTAwOCIgdHJhbnNmb3JtPSJtYXRyaXgoMC45MTY3LDAsMCwwLjkxNjcsMTEuOTk1MjAwMDAwMDAwMDExLDExLjk5NTIwMDAwMDAwMDAxMSkiPjwhLS0/eG1sIHZlcnNpb249IjEuMCI/LS0+PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjg4IiB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSIyODgiPjxwYXRoIGQ9Ik0wIDBoNDh2NDhoLTQ4eiIgZmlsbD0ibm9uZSI+PC9wYXRoPjxwYXRoIGQ9Ik0yNCA4bC0yLjgzIDIuODMgMTEuMTcgMTEuMTdoLTI0LjM0djRoMjQuMzRsLTExLjE3IDExLjE3IDIuODMgMi44MyAxNi0xNnoiIGZpbGw9IiNmZmZmZmYiIGNsYXNzPSJjb2xvcjAwMCBzdmdTaGFwZSI+PC9wYXRoPgoJPG1ldGFkYXRhPgoJCTxyZGY6cmRmIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIgeG1sbnM6cmRmcz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC8wMS9yZGYtc2NoZW1hIyIgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIj4KCQkJPHJkZjpkZXNjcmlwdGlvbiBhYm91dD0iaHR0cHM6Ly9pY29uc2NvdXQuY29tL2xlZ2FsI2xpY2Vuc2VzIiBkYzp0aXRsZT0iQXJyb3csIEZvcndhcmQsIFJpZ2h0LCBQYXRoLCBEaXJlY3Rpb24iIGRjOmRlc2NyaXB0aW9uPSJBcnJvdywgRm9yd2FyZCwgUmlnaHQsIFBhdGgsIERpcmVjdGlvbiIgZGM6cHVibGlzaGVyPSJJY29uc2NvdXQiIGRjOmRhdGU9IjIwMTYtMTItMTQiIGRjOmZvcm1hdD0iaW1hZ2Uvc3ZnK3htbCIgZGM6bGFuZ3VhZ2U9ImVuIj4KCQkJCTxkYzpjcmVhdG9yPgoJCQkJCTxyZGY6YmFnPgoJCQkJCQk8cmRmOmxpPkdvb2dsZSBJbmMuPC9yZGY6bGk+CgkJCQkJPC9yZGY6YmFnPgoJCQkJPC9kYzpjcmVhdG9yPgoJCQk8L3JkZjpkZXNjcmlwdGlvbj4KCQk8L3JkZjpyZGY+CiAgICA8L21ldGFkYXRhPjwvc3ZnPgo8L2c+PC9zdmc+`

export const iconSpinner = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAQAAAC0NkA6AAAAAmJLR0QA/4ePzL8AAAJCSURBVFjD7djBThNhEAdwyrXwAHCT6AtowMQYLdVCNOGEJpRCjCaAb+CVE/gYEIKJRvEhNCC8hsBBIRp6EA/054GvxYXddrsULjB7+r58M//dmflm/rNdXVdUdHvlpe6LBXkBpi8WZB7Md85gyYpCGhDDVjzOBvITVf2tQPSr4kc2kE2w3BJkGXzLBjIMau42A3HHEShljconsCGXBCLnK/iYPfQ3/Imm7BmQaXDo5nkybAFs6wnrSVAOq7xtsHC+NO6xA+Ya7pk2XXef12Cn/gppDD7125biqd0JMB6r8QxMnNot2vTLk3iQD45lzUBkv5B80ZQ8jKwHrAUr7+MVRhyEA4cW23DBiWsXHQYLB4kprc9SyHp26+FNCVG2GzSPLOlrfnjQuroU2ry4sG4wjUJOxXdIX/SUQqpXTi5ua6W82fiMStQYNyffdS2d6oE5k95EnnIbAUxnJdTSqLRNFlpYuRyQnLK3kSebuzpg5VqalJWZNsvK87bKipyp0LuLqXUehQI5lSrUhmxkKPXFhs6GoeZH+y2rNZpWpS13VRpNq2Y5Sm6jn1ztWPutJrjauwQicd+DRMMF9xKIxGq8wqh9m2coUVkNY7EaY6jFUqJ9I+ld0Bs8PRM3zpkN0es9331ZDKmZjxvn5AMXWDwPxEAg3JVEwl0Bf93KDvI5xejw5ThZskIUQ9YPNR2Cbgc6OJINZCvlOLcEtrKB7KUcTPscYC8byKhVw6lG7KLVjO66lJ8FsSCRce7iGNp/49zVk3/z0ExgvRKqEQAAAABJRU5ErkJggg==`

export const KEY_CODE_ENTER = 13

export const sortLocationsBy = (x, y) => (a, b) => {
  const aDistanceDiff = Math.abs(x - a.longitude) + Math.abs(y - a.latitude)
  const bDistanceDiff = Math.abs(x - b.longitude) + Math.abs(y - b.latitude)
  const diff = aDistanceDiff - bDistanceDiff

  if (diff === 0) return 0
  if (diff > 0) return 1
  if (diff < 0) return -1
}

export const fetchLocations = () => {
  let promise = null
  const filterDepartmentTypes = window.filterDepartmentTypes
  if (filterDepartmentTypes) {
    promise = fetch(`${API_URL}GetStoresFiltered`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(filterDepartmentTypes),
    })
  } else {
    promise = fetch(`${API_URL}GetStores`)
  }

  return promise
    .then((res) => res.json())
    .catch((error) => {
      console.error("Error fetching locations:", error)
    })
}
